import type { Nft } from '@0xtorch/core'
import type { Erc721Transfer } from '../../../types'
import type { Erc721TokenTransfer } from '../../../types/erc721'
import { createErc721NftId } from '../../../utils'

type ParseToErc721TokenTransferParameters = {
  chainId: number
  transfer: Erc721Transfer
  nfts: Map<string, Nft>
}

export const parseToErc721TokenTransfer = ({
  chainId,
  transfer,
  nfts,
}: ParseToErc721TokenTransferParameters): Erc721TokenTransfer => {
  const id = createErc721NftId({
    chainId,
    address: transfer.address,
    tokenId: transfer.tokenId,
  })
  const nft = nfts.get(id)
  return {
    ...transfer,
    token: nft ?? {
      type: 'Nft',
      id,
      updatedAt: 0,
    },
  }
}
